import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Truck } from "lucide-react";

export function SuppliersPage() {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-semibold text-foreground mb-1">Suppliers</h1>
        <p className="text-muted-foreground">Manage your supplier relationships</p>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Truck className="w-5 h-5" />
            All Suppliers
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-64 text-muted-foreground">
            Suppliers page content coming soon...
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
